import Myworker from "@domains/utils/all.worker";
export var worker = new Myworker();
